export default __webpack_public_path__ + "static/media/Dewey-Panic-Grass_R1.ef76a518.png";